export default {
    name: 'IterationTitle',
    props: {
        title: {
            type: String,
            required: true
        }
    }
};
